{
  "name": "core-sys",
  "version": "2.4.1",
  "scripts": {
    "ng": "node --max-old-space-size=4096 ./node_modules/@angular/cli/bin/ng.js",
    "start": "ng serve --port=5005",
    "build": "node --max-old-space-size=4096 ./node_modules/@angular/cli/bin/ng.js build",
    "build:verify": "node --max-old-space-size=3072 ./node_modules/@angular/cli/bin/ng.js build --configuration verify",
    "watch": "ng build --watch --configuration development",
    "test:unit": "jest",
    "test:unit:watch": "jest --watch",
    "test:unit:coverage": "jest --coverage",
    "test": "playwright test",
    "test:ui": "playwright test --ui",
    "test:headed": "playwright test --headed",
    "test:debug": "playwright test --debug",
    "test:update-snapshots": "playwright test --update-snapshots",
    "visual": "playwright test tests/e2e/visual --reporter=list",
    "visual:update": "playwright test tests/e2e/visual --update-snapshots --reporter=list",
    "test:report": "playwright show-report",
    "serve:ssr:core-sys": "node dist/core-sys/server/server.mjs",
    "serve": "serve -s ./dist/core-sys/browser -p 5005",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "lint:ratchet": "node tools/lint/lint-ratchet.mjs",
    "lint:ratchet:update": "node tools/lint/lint-ratchet.mjs --update",
    "lint:ratchet:tighten": "node tools/lint/lint-ratchet.mjs --tighten",
    "validate:manifests": "node scripts/validate-feature-manifests.mjs",
    "api:routes": "node tools/api/gen-be-routes.mjs",
    "icons:build": "node tools/fonts/build-icon-subset.mjs",
    "check:templates": "node tools/lint/check-inline-templates.mjs",
    "check:class-bindings": "node tools/lint/check-class-bindings.mjs",
    "icons:check": "node tools/fonts/build-icon-subset.mjs --check",
    "icons:sprites": "node tools/fonts/subset-icon-sprites.mjs",
    "icons:check:sprites": "node tools/fonts/check-icon-sprites.mjs",
    "storybook": "ng run core-sys:storybook",
    "build-storybook": "ng run core-sys:build-storybook",
    "analyze": "ng build --configuration=production --source-map && npx source-map-explorer dist/core-sys/browser/*.js --html dist/bundle-report.html",
    "analyze:dev": "ng build --configuration=development --source-map --named-chunks && ls -lhS dist/core-sys/browser/chunk-*.js | head -30",
    "prebuild": "node tools/build/generate-build-info.mjs",
    "pwa:icons": "node tools/pwa/build-pwa-icons.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.0",
    "@angular/cdk": "^22.0.0",
    "@angular/common": "^22.1.0",
    "@angular/compiler": "^22.1.0",
    "@angular/core": "^22.1.0",
    "@angular/forms": "^22.1.0",
    "@angular/material": "^22.0.0",
    "@angular/platform-browser": "^22.1.0",
    "@angular/platform-browser-dynamic": "^22.1.0",
    "@angular/platform-server": "^22.1.0",
    "@angular/router": "^22.1.0",
    "@angular/service-worker": "^22.1.0",
    "@angular/ssr": "^22.1.0",
    "@microsoft/signalr": "^10.0.11",
    "@ngx-translate/core": "^15.0.0",
    "@tiptap/core": "^3.29.2",
    "@tiptap/extension-code-block-lowlight": "^3.29.2",
    "@tiptap/extension-highlight": "^3.29.2",
    "@tiptap/extension-horizontal-rule": "^3.29.2",
    "@tiptap/extension-image": "^3.29.2",
    "@tiptap/extension-link": "^3.29.2",
    "@tiptap/extension-placeholder": "^3.29.2",
    "@tiptap/extension-table": "^3.29.2",
    "@tiptap/extension-table-cell": "^3.29.2",
    "@tiptap/extension-table-header": "^3.29.2",
    "@tiptap/extension-table-row": "^3.29.2",
    "@tiptap/extension-task-item": "^3.29.2",
    "@tiptap/extension-task-list": "^3.29.2",
    "@tiptap/extension-underline": "^3.29.2",
    "@tiptap/pm": "^3.29.2",
    "@tiptap/starter-kit": "^3.29.2",
    "core-sys": "file:",
    "lodash-es": "^4.17.21",
    "lowlight": "^3.3.0",
    "luxon": "^3.7.2",
    "ng-qrcode": "^22.0.0",
    "ngx-image-cropper": "^7.1.2",
    "ngx-mask": "^22.1.0",
    "ngx-material-timepicker": "^13.1.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "overrides": {
    "minimatch": ">=10.2.1",
    "ajv": ">=8.18.0",
    "serialize-javascript": ">=7.0.4",
    "express-rate-limit": ">=8.3.0",
    "test-exclude": ">=8.0.0",
    "glob": ">=13.0.0",
    "jsdom": ">=28.0.0",
    "undici": ">=7.24.0",
    "eslint": {
      "ajv": "^6.12.6"
    }
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.1.2",
    "@angular-devkit/schematics": "^22.1.2",
    "@angular-eslint/schematics": "^22.1.0",
    "@angular/build": "^22.1.2",
    "@angular/cli": "^22.1.2",
    "@angular/compiler-cli": "^22.1.0",
    "@axe-core/playwright": "^4.10.2",
    "@eslint/js": "^10.0.1",
    "@playwright/test": "1.58.2",
    "@storybook/angular": "^10.5.5",
    "@types/chroma-js": "^2.4.3",
    "@types/jest": "^30.0.0",
    "@types/lodash": "^4.14.202",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^20.19.0",
    "angular-eslint": "^22.1.0",
    "autoprefixer": "^10.4.16",
    "chroma-js": "^2.4.2",
    "eslint": "^10.8.0",
    "jest-environment-jsdom": "^30.2.0",
    "jest-preset-angular": "^17.0.0",
    "listr2": "^9.0.5",
    "lodash": "^4.17.23",
    "postcss": "^8.4.33",
    "storybook": "^10.5.5",
    "tailwindcss": "^3.4.1",
    "ts-node": "^10.9.2",
    "typescript": "^6.0.0",
    "typescript-eslint": "^8.66.0",
    "webpack-dev-server": "^5.2.2"
  },
  "engines": {
    "node": "^24.0.0",
    "npm": ">=10"
  }
}
